





















import {Component, Prop, Vue} from "vue-property-decorator";
import format from "@/valchrom/views/dataset/NumberFormat";
import DecisionIconButtonComponent from "@/valchrom/views/dataset/DecisionIconButtonComponent.vue";

@Component({
    components: {
        DecisionIconButtonComponent
    }
})
export default class CriteriaTable extends Vue {
    name = 'CriteriaTable';
    @Prop() criterias : any;

    format(data: any, field: string){
        return format(data[field], data["name"]);
    }

    getData(){
        let data = [];
        for(let criteria_name in this.criterias) {
            let criteria = this.criterias[criteria_name];
            if(criteria.display){
                data.push({
                    criteria_name,...criteria
                })
            }
        }
        return data;
    }

    activeColumns() {
        return [
            {
                key: "name",
                title: "Criteria"
            },{
                key: "limit",
                title: "Limit"
            },{
                key: "found_value",
                title: "Found"
            },{
                key: "passed",
                title: "Decision"
            }
        ];
    }
}
